import React from 'react';
import {
  Form,
  Popup,
  Divider,
  Icon,
  Label,
} from 'semantic-ui-react';

import { isEmail } from 'validator';
import {
  parseInt,
  isString,
  isEmpty,
  map,
} from 'lodash';

import NetworkHandleInput from '../network-handle-input';
import countries from '../../utils/helpers/countries';
import getChannelData from '../../utils/get-channel-data';
import ThemeSelector from '../../themes/theme-selector';

const HANDLE_PROMPT = 'Enter the your handle, or copy-paste your profile\'s url';
const TERMS_LINK = ThemeSelector.getInfluencerTermsAndConditionsLink();

const blockDisplayStyle = {
  display: 'block',
  width: 100,
};

const isValidEmail = email => isString(email) && isEmail(email);

const toDropdownOptions = list => (isEmpty(list)
  ? []
  : map(list, value => ({ value, text: value })));

class InfluencerSetupForm extends React.Component {
  constructor({ influencer }) {
    super();
    this.state = {
      ...influencer,
      contentTags: influencer.contentTags || [],
      contentTagOptions: toDropdownOptions(influencer.contentTags),
      previousClients: influencer.previousClients || [],
      previousClientsOptions: toDropdownOptions(influencer.previousClients),
      willNotWorkWith: influencer.willNotWorkWith || [],
      willNotWorkWithOptions: toDropdownOptions(influencer.willNotWorkWith),
    };
  }

  handleSocialChange = (_, { name, value }) => {
    this.setState({
      [name]: value,
      [`${name}Loading`]: true,
      [`${name}Error`]: false,
      [`${name}Count`]: 0,
    });
    getChannelData(name, value)
      .then(args => {
        const { count, pageName } = args;
        return this.setState({
          [`${name}Loading`]: false,
          [`${name}Error`]: false,
          [`${name}Count`]: parseInt(count),
          [`${name}PageName`]: pageName,
        }, () => {
          const { onChange } = this.props;
          onChange(this.state);
        });
      })
      .catch(() => this.setState({
        [`${name}Loading`]: false,
        [`${name}Error`]: true,
        [`${name}Count`]: 0,
      }, () => {
        const { onChange } = this.props;
        onChange(this.state);
      }));
  }

  handleToggle = name => {
    this.setState(oldState => ({
      [name]: !oldState[name],
    }), () => {
      const { onChange } = this.props;
      onChange(this.state);
    });
  }

  handleChange = (_, { name, value }) => {
    this.setState({
      [name]: value,
    }, () => {
      const { onChange } = this.props;
      onChange(this.state);
    });
  }

  addToContentTagOptions = (_, { value }) => {
    const { contentTagOptions } = this.state;
    this.setState({
      contentTagOptions: [...contentTagOptions, { value, text: value }],
    });
  }
  addToPreviousClientsOptions = (_, { value }) => {
    const { previousClientsOptions } = this.state;
    this.setState({
      previousClientsOptions: [...previousClientsOptions, { value, text: value }],
    });
  }
  addToWillNotWorkWithOptions = (_, { value }) => {
    const { willNotWorkWithOptions } = this.state;
    this.setState({
      willNotWorkWithOptions: [...willNotWorkWithOptions, { value, text: value }],
    });
  }

  render = () => {
    const {
      name,
      country, countryBlurred,
      email, emailBlurred,
      instagram, instagramCount,
      facebook, facebookError, facebookLoading, facebookCount,
      twitter, twitterError, twitterLoading, twitterCount,
      youtube, youtubeError, youtubeLoading, youtubeCount, youtubePageName,
      web,
      contentTags, contentTagOptions,
      previousClients, previousClientsOptions,
      willNotWorkWith, willNotWorkWithOptions,
      agreedToTermsOfUse, agreedToShareWithDyzio,
      setupComplete,
      contactNumber,
      addressLine1,
      region,
      postalCode,
      city,
    } = this.state;

    const { captureInfluencerAddressDetails, copy: { applicationFormInstructions } } = ThemeSelector.theme();


    const nameError = isEmpty(name);
    const countryError = countryBlurred && isEmpty(country);
    const emailError = emailBlurred && (isEmpty(email) || !isValidEmail(email));
    return (
      <div>
        <h2> Influencer Application Form </h2>
        <Divider hidden />
        {applicationFormInstructions}

        <Divider hidden />
        <Form>
          <Form.Group widths="equal">
            <Form.Input
              label={'Name'} value={name} name="name" onChange={this.handleChange}
              error={nameError}
              required
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Dropdown
              options={countries}
              selection
              error={countryError}
              search
              label={'Country'}
              onBlur={() => this.handleChange(null, { name: 'countryBlurred', value: true })}
              value={country}
              name="country"
              onChange={this.handleChange}
              required
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Input
              label={'Email Address'} value={email} name="email" onChange={this.handleChange}
              error={emailError}
              onBlur={() => this.handleChange(null, { name: 'emailBlurred', value: true })}
              placeholder="Preferred contact email address"
              required
            />
          </Form.Group>

          {
            captureInfluencerAddressDetails &&
            <div>
              <Divider />

              <h4>Business Address Details</h4>
              <Divider hidden />

              <Form.Input
                width={12}
                label="Contact Number"
                name="contactNumber"
                onChange={this.handleChange}
                value={contactNumber}
              />
              <Form.Input
                width={12}
                label="Address Line One"
                name="addressLine1"
                onChange={this.handleChange}
                value={addressLine1}
              />
              <Form.Input
                width={12}
                label="City"
                name="city"
                onChange={this.handleChange}
                value={city}
              />
              <Form.Input
                width={12}
                label="Region"
                name="region"
                onChange={this.handleChange}
                value={region}
              />
              <Form.Input
                width={12}
                label="Postal Code"
                name="postalCode"
                onChange={this.handleChange}
                value={postalCode}
              />
            </div>
          }
          <Divider />

          <Form.Group widths="equal">
            <Form.Field>
              <span style={blockDisplayStyle}>Instagram</span>
              <NetworkHandleInput
                network="instagram"
                readOnly
                value={instagram}
                count={instagramCount}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field error={facebookError}>
              <Popup
                position="left center"
                trigger={<span style={blockDisplayStyle}>Facebook<img src="/icons/info.svg" alt="info" /></span>}
                content={HANDLE_PROMPT}
              />
              <NetworkHandleInput
                network="facebook"
                error={facebookError}
                value={facebook}
                loading={facebookLoading}
                onChange={this.handleSocialChange}
                count={facebookCount}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field error={twitterError}>
              <Popup
                position="left center"
                trigger={<span style={blockDisplayStyle}>Twitter<img src="/icons/info.svg" alt="info" /></span>}
                content={HANDLE_PROMPT}
              />
              <NetworkHandleInput
                network="twitter"
                error={twitterError}
                value={twitter}
                loading={twitterLoading}
                onChange={this.handleSocialChange}
                count={twitterCount}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field error={youtubeError}>
              <Popup
                position="left center"
                trigger={<span style={blockDisplayStyle}>YouTube<img src="/icons/info.svg" alt="info" /></span>}
                content={HANDLE_PROMPT}
              />
              <NetworkHandleInput
                network="youtube"
                error={youtubeError}
                value={youtube}
                loading={youtubeLoading}
                onChange={this.handleSocialChange}
                count={youtubeCount}
              />
            </Form.Field>
          </Form.Group>

          {
            youtubePageName
              ? <Label size="large" color="green" basic>{youtubePageName}</Label>
              : <Label size="large" color="grey" basic>{
                youtubeLoading
                  ? 'loading...'
                  : 'Youtube Channel Title'
              }</Label>
          }

          <Divider />

          <Form.Group widths="equal">
            <Form.Input
              width={12}
              label={
                <span>
                  <Icon name="world" color="blue" />
                  Website or Blog
                </span>
              }
              placeholder="Website or Blog"
              name="web"
              onChange={this.handleChange}
              value={web}
            />
          </Form.Group>

          <Divider />

          <Form.Group widths="equal">
            <Form.Dropdown
              width={12}
              label="×5 Content tags that would best describe you and your content"
              placeholder="e.g. football, comedy"
              name="contentTags"
              noResultsMessage="Enter tags that would best describe you"
              options={contentTagOptions}
              value={contentTags}
              onChange={this.handleChange}
              onAddItem={this.addToContentTagOptions}
              search selection multiple allowAdditions
            />
          </Form.Group>

          <Form.Group widths="equal">
            <Form.Dropdown
              width={12}
              label="×5 Clients you have worked with"
              placeholder="e.g. Audi, American Airlines..."
              name="previousClients"
              noResultsMessage="Enter clients that you have worked with"
              options={previousClientsOptions}
              value={previousClients}
              onChange={this.handleChange}
              onAddItem={this.addToPreviousClientsOptions}
              search selection multiple allowAdditions
            />
          </Form.Group>

          <Form.Group widths="equal">
            <Form.Dropdown
              width={12}
              label="Are there any sectors or brands you will not work this?"
              placeholder="e.g. Alcohol, airlines"
              name="willNotWorkWith"
              noResultsMessage="Enter any clients you would not work with"
              options={willNotWorkWithOptions}
              value={willNotWorkWith}
              color="red"
              onChange={this.handleChange}
              onAddItem={this.addToWillNotWorkWithOptions}
              search selection multiple allowAdditions
            />
          </Form.Group>

          {!setupComplete && (
            <div>
              <Divider />
              <Form.Group widths="equal">
                <Form.Checkbox
                  required
                  value={agreedToTermsOfUse}
                  name="agreedToTermsOfUse"
                  onChange={() => this.handleToggle('agreedToTermsOfUse')}
                  label={
                    <label>
                      I have read and agree to
                      <a rel="noopener noreferrer" target="_blank" href={TERMS_LINK}> the terms of use </a>
                    </label>
                  }
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Checkbox
                  required
                  value={agreedToShareWithDyzio}
                  name="agreedToShareWithDyzio"
                  onChange={() => this.handleToggle('agreedToShareWithDyzio')}
                  label={<label>I agree for my data to be shared with Dyzio</label>}
                />
              </Form.Group>
            </div>
          )}

          <Divider hidden />
        </Form>
      </div>
    );
  }
}

export default InfluencerSetupForm;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-setup-form/index.js
 **/